"use client";

import Loading from "@/components/Loading";
import DuThreeColSection from "./DuThreeColSection";
import DuCorrectScoresSection from "./DuCorrectScoresSection";
import "./index.css";

export default function DuOtherBetsDropdown({
  loadingOtherOdds,
  otherOddsData,
  hasOtherData,
  correctScoresListFull = [],
  correctScoresFull = { home: [], draw: [], away: [] },
  totalCornersOdds = [],
  odds = {},
  showOther,
}) {
  return (
    <div
      className={`du-odt-wrapper kbv-hbet-odt-bg min-w-0 overflow-hidden px-1 py-1 ${
        showOther ? "active" : ""
      }`}
    >
      {loadingOtherOdds && (
        <div className="flex items-center justify-center w-full py-8">
          <Loading />
        </div>
      )}
      {!loadingOtherOdds && otherOddsData && !hasOtherData && (
        <div className="du-odt-empty">Chưa có dữ liệu kèo cược từ hệ thống</div>
      )}
      {!loadingOtherOdds && hasOtherData && (
        <div className="du-odds-detail-table">
          <div className="flex flex-wrap gap-1 md:gap-y-[10px] md:gap-x-4">
            <DuThreeColSection
              title="Kèo phạt góc"
              items={[
                {
                  label: "Đội nhà",
                  value: totalCornersOdds?.[0]?.over,
                  trend: totalCornersOdds?.[0]?.initialOverTrend,
                },
                {
                  label: "Đội khách",
                  value: totalCornersOdds?.[0]?.under,
                  trend: totalCornersOdds?.[0]?.initialUnderTrend,
                },
                { label: "Hòa", value: null },
              ]}
              width="ods-100"
            />

            <DuThreeColSection
              title="FT 1x2"
              items={[
                { label: "Đội nhà", value: odds?.homeEuropeOdds, trend: odds?.homeEuropeTrend },
                { label: "Đội khách", value: odds?.awayEuropeOdds, trend: odds?.awayEuropeTrend },
                { label: "Hòa", value: odds?.instantDrawOdds, trend: odds?.drawTrend },
              ]}
              width="ods-50"
            />

            <DuThreeColSection
              title="HT 1x2"
              items={[
                { label: "Đội nhà", value: odds?.homeHandicapHalfOdds, trend: odds?.homeHandicapHalfTrend },
                { label: "Đội khách", value: odds?.awayHandicapHalfOdds, trend: odds?.awayHandicapHalfTrend },
                { label: "Hòa", value: null },
              ]}
              width="ods-50"
            />

            {correctScoresListFull.length > 0 && (
              <DuCorrectScoresSection
                title="Tỷ số chính xác toàn trận"
                correctScoresFull={correctScoresFull}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}

